export {
  ArticleContent,
  ArticleProse,
  type ArticleContentProps,
  type ArticleProseProps,
} from "./ArticleContent";
